import { QbBusiness } from '../../utils/business/qbbusiness'
import { BusinessResponseHandler } from '../BusinessResponseHandler'

export class TrackController {

	static fetchTrackUrl(trackId, quality, intent, ignoreHandleConnect) {
		return QbBusiness.trackGet(trackId, quality, intent, ignoreHandleConnect)
			.then(response => BusinessResponseHandler.handleResponse(response))
			.catch(error => {
				throw error
			})
	}

	static fetchSingleTrack(trackId) {
		return QbBusiness.getTrack(trackId)
			.then(response => BusinessResponseHandler.handleResponse(response))
			.catch(error => {
				throw error
			})
	}

	static fetchTrackStatus(tracks) {
		return QbBusiness.trackGetStatus(tracks)
			.then(response => BusinessResponseHandler.handleResponse(response))
			.catch(error => {
				throw error
			})
	}
}



// WEBPACK FOOTER //
// ./src/utils/controllers/TrackController.js